import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import {
  DefaultBrokerPageStore,
  DefaultBrokerPageStoreContext,
} from 'store/pages/enrollment/broker/broker-default/pageStore';
import PageContent from 'components/enrollment/broker/broker-default';
import { useEnrollmentDomainParams } from 'global/hooks/useEnrollmentDomainParams';
import { PageWrapperStyled } from '../../../../globalStyles';

/* TESTING_POLICY: CYPRESS_ONLY */

const DefaultBrokerPage: React.FC = () => {
  const { groupId, periodId } = useEnrollmentDomainParams();
  const pageStore = useMemo(() => new DefaultBrokerPageStore({ groupId, periodId }), [groupId, periodId]);

  return (
    <ProposalStatusLayout>
      <DefaultBrokerPageStoreContext.Provider value={pageStore}>
        <PageWrapperStyled>
          <PageContent />
        </PageWrapperStyled>
      </DefaultBrokerPageStoreContext.Provider>
    </ProposalStatusLayout>
  );
};

export default observer(DefaultBrokerPage);
